import { render, staticRenderFns } from "./location-ctrl.vue?vue&type=template&id=20bbbe0a&scoped=true&"
import script from "./location-ctrl.vue?vue&type=script&lang=js&"
export * from "./location-ctrl.vue?vue&type=script&lang=js&"
import style0 from "./location-ctrl.vue?vue&type=style&index=0&id=20bbbe0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbbe0a",
  null
  
)

export default component.exports